import { useMemo } from 'react';
import { citations, reactions } from '@Constants';
import Breadcrumb from '@Services/Breadcrumb';

const useSummaryAvailable = ({ activeBreadcrumb }) => {
  const rootBreadcrumb = useMemo(() => Breadcrumb.retrieveRootActiveBreadcrumb(activeBreadcrumb), [activeBreadcrumb]);
  const isDocumentSummaryContext = activeBreadcrumb?.context === citations;
  const isReactionSummaryContext = activeBreadcrumb?.context === reactions;
  const isReactionSummaryVisible =
    (rootBreadcrumb?.reactionSummaryEligible || activeBreadcrumb?.reactionSummaryEligible) && isReactionSummaryContext;

  // Show the summary section when the root result set has a summary-capable
  // context, so filtered result sets can render the stale-summary message.
  const isSummarySectionVisible = useMemo(
    () =>
      !activeBreadcrumb?.hideSummary && ((rootBreadcrumb?.semanticSearchIncluded && isDocumentSummaryContext) || isReactionSummaryVisible),
    [rootBreadcrumb, activeBreadcrumb, isDocumentSummaryContext, isReactionSummaryVisible]
  );

  // The current result set can render a summary only on the root result set and
  // only for a supported summary context.
  const isSummaryAvailable = useMemo(
    () =>
      !activeBreadcrumb?.hideSummary &&
      activeBreadcrumb?.resultName === rootBreadcrumb?.resultName &&
      ((activeBreadcrumb?.semanticSearchIncluded && isDocumentSummaryContext) ||
        (activeBreadcrumb?.reactionSummaryEligible && isReactionSummaryContext)),
    [rootBreadcrumb, activeBreadcrumb, isDocumentSummaryContext, isReactionSummaryContext]
  );

  return {
    isSummarySectionVisible,
    isSummaryAvailable,
    isReactionSummary: isReactionSummaryContext && !!activeBreadcrumb?.reactionSummaryEligible,
  };
};

export default useSummaryAvailable;
